module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"invoices":"Factoring invoices","schedule":"Schedule"},"et":{"invoices":"Factoring invoices","schedule":"Schedule"},"ru":{"invoices":"Factoring invoices","schedule":"Schedule"}}')
  delete Component.options._Ctor
}
